import { Component, OnInit } from '@angular/core';
import { MyAccountService } from '../../services/my-account.service';
import { RoleService } from '../../services/role.service';
import { AccountDetailsModel } from '../../models/account-details-model';
import {formatPhone, formatPhoneNumeric} from '../../providers/app-date-adapter';
import {ContentRowField} from '../../shared/content-row/content-row.component';
import {AuthUserInfoModel} from "../../models/auth-user-info-model";

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.css']
})
export class MyAccountComponent implements OnInit {

  accountDetails: AccountDetailsModel;

  accountFields = [
    { header: 'User name', cell: (row: AccountDetailsModel) => `${row.userName}` },
    { header: 'First name', cell: (row: AccountDetailsModel) => `${row.firstName}` },
    { header: 'Last name', cell: (row: AccountDetailsModel) => `${row.lastName}` },
    { header: 'Phone', cell: (row: AccountDetailsModel) => `${formatPhone(row.phone)}` },
    {
      header: 'Two-Factor Auth',
      cell: (row: AccountDetailsModel) => `${row.isTotpActive ? 'Active':'Inactive'}`,
      icon: (row: AccountDetailsModel) => `${row.isTotpActive ? 'check':'close'}`,
      iconColor: (row: AccountDetailsModel) => `${row.isTotpActive ? 'forestgreen':'red'}`
    },
    { header: 'Roles', cell: (row: AccountDetailsModel) => row.roles.join(', ') },
  ] as ContentRowField<AccountDetailsModel>[];


  constructor(
    private myAccountService: MyAccountService,
    private roleService: RoleService,
    ) { }

  ngOnInit() {
    this.myAccountService.getAccountDetails().subscribe(result => {
      this.accountDetails = result;
    });
  }

}
